import { Component, ElementRef , ViewChild, TemplateRef} from '@angular/core';
import {NgbModal}   from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import {HttpClient,HttpClientModule,HttpHeaders,} from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApidataService } from '../apidata.service';
import { Router} from '@angular/router';
import { environment, GINConstants } from '../../environments/environments';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
@Component({
  selector: 'app-download',
  standalone: true,
  imports: [NgbDatepickerModule, HttpClientModule,CommonModule,
    ReactiveFormsModule,
    FormsModule,IconsFreeToolsComponent
   ],
  templateUrl: './download.component.html',
  styleUrl: './download.component.css'
})
export class DownloadComponent {
  closeResult = '';
  undoLimit: number = 5;
  showUndo: boolean = false;
  showRedo: boolean = false;

  file_name: string = '';
  docTitle = "Untitled document";
  saveFileText2 = "";
  savefiletexttt = "";
  profile_id = "";
  doc_id = this.router.url.split('/').pop();
  visible: boolean = false;
  visibleforsave: boolean = false;

  autosavedlist: boolean = false;
  all_records = [];
  itemsCopy;
  dataListings: any[] = [];
 dataListings2: any[] = [];
 titlelist = [];
 checkdate = [];

 Contents;
 wordList;
 lodershow: boolean = false;
 loaderAlert: boolean = false;
 checkingTime = 0;
 addonlyfortesting;
 iLastTime = 0;
 iTime = 0;
 iTotal = 0
 iKeys = 0;
 writtingStarted = 0;
 char_count;
 word_count;
 checkwords: boolean = false;
 dataCurrentArray: Array<any> = [];
 dataUndoArray: Array<any> = [];
 dataRedoArray: Array<any> = [];

 saveFileText = "";


  constructor(private modalService: NgbModal,
    private router: Router,
    private apiservice: ApidataService,
     private http:HttpClient ,
    private elementRef: ElementRef,) {}


  @ViewChild('content', { static: true }) content: TemplateRef<any>;

  ngOnInit() {
    this.openModal();

  }


  openModal() {
    this.modalService.open(this.content,{ backdrop: 'static', keyboard: false , centered: true,windowClass: 'my-class'});
  }

  openModels(content:any, data:any=null){
    this.modalService.open(content,{size:"lg"})
    }
    closeModal(){
      this.modalService.dismissAll();
    }


    public downloadWordDocument() {
      const mmContent = document.getElementById("mm")?.innerHTML; 
    
      if (mmContent) {
        const content = `
          <html xmlns:o='urn:schemas-microsoft-com:office:office'
          xmlns:w='urn:schemas-microsoft-com:office:word'
          xmlns='http://www.w3.org/TR/REC-html40'>
         <head><meta charset='utf-8'><title>Grammarin Report</title></head>
          <body>${this.preserveTextAlignment(this.convertBulletListsToUnordered(mmContent))}</body>
          </html>`;
    
        const blob = new Blob(['\ufeff', content], { type: 'application/msword' });
    
        const filename = `Grammarin-Report-${this.doc_id}.doc`;
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        // console.error('No content found in #mm for Word export');
      }
      this.closeModal();
    }

    private convertBulletListsToUnordered(html: string): string {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      doc.querySelectorAll("ol").forEach((ol) => {
        const listItems = ol.querySelectorAll('li[data-list="bullet"]');

        if (listItems.length > 0) {
          const ul = document.createElement("ul");

          listItems.forEach((li) => ul.appendChild(li));

          ol.replaceWith(ul);
        }
      });

      return doc.body.innerHTML;
    }

    private preserveTextAlignment(html: string): string {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      function updateStyle(className, textAlignValue) {
        doc.querySelectorAll(`.${className}`).forEach(el => {
          (el as HTMLElement).style.textAlign = textAlignValue;
        });
      }

      updateStyle("ql-align-center", "center");
      updateStyle("ql-align-right", "right");
      updateStyle("ql-align-justify", "justify");

      return doc.body.innerHTML;
    }
    
    @ViewChild('DownloadModal') DownloadModal: ElementRef;
    public downloadPdf3() {
      const el = document.getElementById("mm");

      if (!el) return;

      const content = el.innerHTML
        .replace(/<span[^>]*>/g, '')
        .replace(/<\/span>/g, '');

      const doc = new jsPDF();

      doc.html(this.preserveTextAlignment(this.convertBulletListsToUnordered(content)), {
        callback: (pdf) => {
          pdf.save(`Grammarin-Report-${this.doc_id}.pdf`);
        },
        x: 10,
        y: 10,
        width: 180,
        windowWidth: el.scrollWidth,
      })

      this.closeModal();
    }
    // download code end
}
